const storeLinkClick = store => ({
  type: 'STORE_LINK_CLICK',
  store,
});

export default {
  storeLinkClick,
};
